export default __webpack_public_path__ + "static/lifemedicineacademy-37127d4e6b69570f0376324de354b935.png";